export default {
  state: {
    sectors: {
      loading: false,
      items: [],
      refresh: false,
      scrollElement: null
    },
    filters: {
      search: '',
      startDate: null,
      endDate: null
    }
  },
  mutations: {
    setCoverageSectorsLoading (state, value) { state.sectors.loading = value },
    setCoverageSectors (state, value) { state.sectors.items = value },
    setCoverageSectorsRefresh (state, value) { state.sectors.refresh = value },
    setCoverageSectorScrollElement(state, value) { state.sectors.scrollElement = value },
    setCoverageSectorsPanelShow (state, index) {
      state.sectors.items[index].showPanel = !state.sectors.items[index].showPanel
      if (state.sectors.items[index].showPanel) {
        state.sectors.items[index].bodyHeight = 'auto'
      } else {
        state.sectors.items[index].bodyHeight = 0
      }
    },
    setCoverageSectorsIssueState (state, value) {
      let sectors = state.sectors.items
      let index = -1
      let i = -1
      for (i = 0; i < sectors.length; i++) {
        if (value.id !== sectors[i].ID) {
          continue
        }
        index = i
        break
      }

      if (i < 0) {
        return
      }

      state.sectors.items[i].issueState = value.hasIssues ? 'has-issues' : 'ok'
      state.sectors.items[i].shiftGaps = value.shiftGaps
      state.sectors.items[i].unassigned = value.unassigned
    },
    setCoverageSectorPolygonOption (state, value) {
      let sectors = state.sectors.items
      let index = -1
      let i = -1
      for (i = 0; i < sectors.length; i++) {
        if (value.id !== sectors[i].ID) {
          continue
        }
        index = i
        break
      }

      if (i < 0) {
        return
      }

      state.sectors.items[i].polygonOptions = value.polygonOptions
    },
    resetCoverageSectorPolygonOption (state) {
      let sectors = state.sectors.items
      for (let i = 0; i < sectors.length; i++) {
        sectors[i].polygonOptions = {
          zIndex: 0,
          strokeWeight: 2,
          fillOpacity: 0.25
        }
      }
      state.sectors.items = sectors
    },
    resetCoverageSectorBodyHeight (state, value) {
      let sectors = state.sectors.items
      let index = -1
      let i = -1
      for (i = 0; i < sectors.length; i++) {
        if (value.id !== sectors[i].ID) {
          continue
        }
        index = i
        break
      }

      if (i < 0) {
        return
      }

      state.sectors.items[i].bodyHeight = value.bodyHeight
    },
    setCoverageFilterSearch (state, value) { state.filters.search = value },
    setCoverageFilterStartDate (state, value) { state.filters.startDate = value },
    setCoverageFilterEndDate (state, value) { state.filters.endDate = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/coverage/coverage-sectors.js